import React, { ReactNode } from 'react';

const PageFooter = ({
    children,
}: {
    children?: ReactNode;
}): React.JSX.Element => {
    return <div id='footer-container'>{children}</div>;
};

export default PageFooter;
